export default "__VITE_ASSET__anoUUgE___"